import { TuiBadge } from '@taiga-ui/kit';

export type BadgeSize = TuiBadge['size'];

export const enum BadgeColors {
  Green = 'green',
  Grey = 'grey',
  Yellow = 'yellow',
  Red = 'red',
  White = 'white',
  Blue = 'blue',
}
export type BadgeColor = 'green' | 'grey' | 'yellow' | 'red' | 'white' | 'blue';

export interface BadgeOptions {
  value: string;
  color: BadgeColor;
  size: BadgeSize;
}
